module.exports = __webpack_public_path__ + "static/media/4C.037d8c23.svg";